import axiosInstance from './axiosInstance'

// export const getProjectContactById = (vendorId) => {
//   return axiosInstance.get(`/project-contacts/${vendorId}`)
// }

export const getProjectContacts = (projectId, page = 1, limit = 50, search = '', orderByKey = 'name', direction = 'asc') => {
  return axiosInstance.get(`/project-contacts?projectId=${projectId}&page=${page}&limit=${limit}&search=${search}&orderByKey=${orderByKey}&direction=${direction}`)
}

export const createProjectContact = (data) => {
  return axiosInstance.post('/project-contacts', data)
}

export const updateProjectContact = (contactId, data) => {
  return axiosInstance.put(`/project-contacts/${contactId}`, data)
}

export const deleteProjectContact = (vendorId) => {
  return axiosInstance.delete(`/project-contacts/${vendorId}`)
}
